import React from 'react';
import { t } from 'i18next';
import { PersonOff, Sync } from '@mui/icons-material';

import TooltipComponent from '../../../../../components/TooltipComponent';
import { IRecognitionSimpleProps } from '../../../../../services/Recognition/types';

interface RecognitionNameCellProps {
  row: IRecognitionSimpleProps;
}

const RecognitionNameCell = ({ row }: RecognitionNameCellProps) => {
  const isInactive = row.isActive === false;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span
        style={{
          borderBottom: row.isTemporary ? '2px solid #ed6c02' : 'none',
          color: isInactive ? '#9e9e9e' : row.isTemporary ? '#ed6c02' : 'inherit',
          fontStyle: isInactive ? 'italic' : 'normal',
          fontWeight: row.isTemporary || isInactive ? 'bold' : 'normal',
          transition: 'all 0.3s ease',
          opacity: isInactive ? 0.7 : 1,
        }}
      >
        {row.name}
      </span>

      {row.isTemporary && (
        <TooltipComponent title="Sincronização com dispositivos pendente">
          <Sync
            sx={{
              fontSize: '16px',
              color: '#ed6c02',
              animation: 'spin 2s linear infinite',
              '@keyframes spin': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' },
              },
            }}
          />
        </TooltipComponent>
      )}

      {isInactive && (
        <TooltipComponent title={t('recognitionPage.modalEditFace.filterDisabled') || 'Desativado'}>
          <PersonOff style={{ fontSize: '18px', color: '#9e9e9e' }} />
        </TooltipComponent>
      )}
    </div>
  );
};

export default RecognitionNameCell;